import { differenceInCalendarDays, format, isValid, parseISO } from 'date-fns'

/** Cards store `YYYY-MM-DD`; parse as local midnight so no timezone shifts it. */
export function parseDueDate(value: string | null): Date | undefined {
  if (!value) return undefined
  const date = parseISO(`${value}T00:00:00`)
  return isValid(date) ? date : undefined
}

export const toIsoDate = (date: Date): string => format(date, 'yyyy-MM-dd')

export type DueTone = 'overdue' | 'today' | 'soon' | 'later'

export function describeDueDate(value: string | null): { label: string; tone: DueTone } | null {
  const date = parseDueDate(value)
  if (!date) return null

  const days = differenceInCalendarDays(date, new Date())
  if (days < 0) return { label: days === -1 ? 'Yesterday' : format(date, 'd MMM'), tone: 'overdue' }
  if (days === 0) return { label: 'Today', tone: 'today' }
  if (days === 1) return { label: 'Tomorrow', tone: 'soon' }
  if (days <= 6) return { label: format(date, 'EEEE'), tone: 'soon' }

  const sameYear = date.getFullYear() === new Date().getFullYear()
  return { label: format(date, sameYear ? 'd MMM' : 'd MMM yy'), tone: 'later' }
}

export const formatDoneAt = (value: string): string => format(parseISO(value), 'd MMM, h:mmaaa')
